import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import "./i18n/i18n";

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If the page was prerendered (scripts/prerender.js), #root already holds the
// painted markup — hydrate on top of it so there's no flash. Otherwise (dev, or
// a route that wasn't prerendered) mount fresh.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// Log the deployed build version/timestamp (from public/version.json, written
// at build time by scripts/gen-version.js) so the live build is identifiable.
fetch(`${process.env.PUBLIC_URL}/version.json`, { cache: "no-store" })
  .then((r) => r.json())
  .then((v) => console.log(`%cTactics build ${v.version} — ${v.built}`, "color:#4ade80;font-weight:bold"))
  .catch(() => {});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
